import React, { useEffect, useState, ReactNode, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, round } from 'lodash';

import './scss/change-rate.scss';
import SubTitle from '../component/sub-title';
import Color from '@/tool/color';

import Tab from '../component/tab';
import TimeTab from '../component/time-tab';
import moChangeRate, { changeTab, changeTimeTab } from './store/change-rate';
import Empty from '@/component/empty';
import { newRateABS } from '@tool/index';
import moEffect from '../store';
import moMenu from '../store/menu';


interface IProps { }
interface IState { }

const ChangeRate = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { rateTabActive, rateTimeActive, rateList } = moChangeRate;

  const tabList = [
    '人均营业收入', '人均净利润', '人均薪酬成本',
  ];
  const emen: any = {
    人均营业收入: 'revenue_per_staff',
    人均净利润: 'profit_per_staff',
    人均薪酬成本: 'cost_per_staff',
  };

  const getData = useMemo(() => {
    const active = emen[rateTabActive];
    let list: any = {};
    let child: any = [];
    let allCompany = 1;
    if (!isEmpty(rateList)) {
      list = rateList[active];
      rateList[active].distribution.forEach((ele: any) => {
        if (ele.count > allCompany) {
          allCompany = ele.count;
        }
      });
      child = rateList[active].distribution.map((res: any, r: any) => {
        const item: any = {};
        if (r < 4) {
          item.type = 'down';
        }
        if (r === 4) {
          item.type = 'stable';
        }
        if (r > 4) {
          item.type = 'up';
        }
        item.value = res.count;
        item.label = res.label;
        return item;
      });
    }
    return { list, child, allCompany };
  }, [rateList, rateTabActive]);

  const tabChange = (val: string) => {
    changeTab(val);
  };

  const timeTabChange = (val: string) => {
    changeTimeTab(val);
  };

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect03" className="change-rate-warp human-common">
      <SubTitle title='变化率分布' subtitle={moMenu.industryName} bg={Color.primaryColor(0.1)}
        color={Color.primary} />
      <section className="tabs">
        <Tab list={tabList} active={rateTabActive} onChange={tabChange} />
      </section>
      {!isEmpty(getData?.child) && getData.child.filter((res: any) => res.value !== 0).length > 0 ? (<section className="rate-chart">
        <section className="content-05010 content-05011">
          <section className="content-05015 content-05017">
            <section className="box-001">
              <b className='left-001'>
                {round(getData?.list?.decline_rate * 100, 0)}%
              </b>
              <b className='right-001'>
                {round(getData?.list?.increase_rate * 100, 0)}%
              </b>
              <p className="line-001">
                <b>{getData?.list?.decline_count}家企业{rateTabActive}下降</b>
                <b>{getData?.list?.increase_count}家企业{rateTabActive}增长</b>
              </p>
              <p className="line-002">
                <b style={{
                  width: `${getData?.list?.decline_count * 100 / getData.allCompany}%`,
                }} />
                <span style={{
                  width: `${getData.child[4].value * 100 / getData.allCompany}%`,
                }}>
                  <i />
                </span>
                <strong style={{
                  width: `${getData?.list?.increase_count * 100 / getData.allCompany}%`,
                }} />
              </p>
            </section>
            <section className="box-002">
              <section className="section-01 section-03">
                {getData.child.map((item: any, index: number) => (
                  <p key={index}
                    className={[
                      'item-002',
                      item.type === 'up' ? 'up-002' : '',
                      item.type === 'down' ? 'down-002' : '',
                      item.type === 'stable' ? 'stable-002' : '',
                    ].join(' ')}>
                    <b>{item.value}家</b>
                    <strong style={{
                      height: `${item.value * 100 / getData.allCompany}%`,
                    }} />
                  </p>
                ))}
              </section>
              <p className="section-01 section-02">
                {getData.child.map((item: any, index: number) => (
                  <span key={index}>{item.label}</span>
                ))}
              </p>
            </section>
          </section>
        </section>
      </section>) : (
        <Empty />
      )}
      <section className="time-tabs">
        <TimeTab list={moEffect.yearList} active={rateTimeActive} onChange={timeTabChange} />
      </section>
    </section>
  );
};

export default observer(ChangeRate);
